export const STANDARD = 'STANDARD';
export const DEFAULT = 'DEFAULT';
export const FORECAST = 'FORECAST';
export const DESC = 1;
export const ASC = -1;

// Roles and principal types are sourced from the generated CHIRP enums (the
// `unhandledEnumCase` symbol member is stripped so the View model only carries
// concrete values).
export const VIEW_SHARE_ROLE = {
  OWNER: 'OWNER',
  COLLABORATOR: 'COLLABORATOR',
  MEMBER: 'MEMBER'
};
export const VIEW_SHARE_PRINCIPAL_TYPE = {
  USER: 'USER',
  TEAM: 'TEAM'
};
export const VisualizationEnum = {
  list: 'list',
  board: 'board',
  report: 'report',
  map: 'map',
  gantt: 'gantt',
  calendar: 'calendar'
};